import { render, staticRenderFns } from "./SectionSubQuiz.vue?vue&type=template&id=0628c0e3&scoped=true&"
import script from "./SectionSubQuiz.vue?vue&type=script&lang=js&"
export * from "./SectionSubQuiz.vue?vue&type=script&lang=js&"
import style0 from "./SectionSubQuiz.vue?vue&type=style&index=0&id=0628c0e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0628c0e3",
  null
  
)

export default component.exports